import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { ModalInput as TextAreaInput } from "../../shared/Style/Style";
import { TrainerContext } from "../context";
import { InfoBlock } from "../styles";
import { InAppPurchasesEnum } from "../../../generated/graphql";

export const TrainerInfoBlock = () => {
    const typeAccess = [
        {
          accessType: InAppPurchasesEnum.Free,
          text: "Безоплатно",
        },
        {
          accessType: InAppPurchasesEnum.Subscribe,
          text: "За підпискою",
        },
        {
          accessType: InAppPurchasesEnum.Purchases,
          text: "За окрему ціну",
        },
    ];
    
    return (
        <TrainerContext.Consumer>
            {({ data, updateTrainerData }) => (
                <InfoBlock>
                    <TextAreaInput
                        key="name"
                        type="text"
                        variant="filled"
                        margin="normal"
                        fullWidth
                        label="Назва тренажера *"
                        value={data.name || ""}
                        onChange={({ target: { value } }) => updateTrainerData("name", value)}
                    />
                    <TextAreaInput
                        key="description"
                        type="text"
                        variant="filled"
                        margin="normal"
                        fullWidth
                        multiline
                        minRows={4}
                        label="Опис"
                        value={data.description || ""}
                        onChange={({ target: { value } }) => updateTrainerData("description", value)}
                    />
                    <Autocomplete
                        key="accessType"
                        fullWidth
                        options={typeAccess.map((item) => item.accessType)}
                        value={
                            typeAccess.find((item) => item.accessType === data.accessType)
                                ?.accessType || null
                        }
                        onChange={(_, value) => updateTrainerData("accessType", value)}
                        getOptionLabel={(option) =>
                            typeAccess.find((item) => item.accessType === option)?.text
                        }
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Доступ до контенту"
                                variant="filled"
                                margin="normal"
                            />
                        )}
                    />
                  <FormControlLabel
                        control={
                            <Checkbox
                                color="primary"
                                checked={data.isForWeb || false}
                                onChange={(e) => updateTrainerData("isForWeb", e.target.checked)}
                            />
                        }
                        label="Тренажер тільки для веб-версії"
                    />
                  {data.accessType === InAppPurchasesEnum.Purchases && (
                        <TextAreaInput
                            key="price"
                            type="number"
                            variant="filled"
                            margin="normal"
                            fullWidth
                            label="Ціна"
                            value={data.price}
                            onChange={({ target: { value } }) => updateTrainerData("price", Number(value))}
                        />
                    )}
                    <TextAreaInput
                        key="dictionaries"
                        type="text"
                        variant="filled"
                        margin="normal"
                        fullWidth
                        multiline
                        minRows={6}
                        label="Словники (через кому)"
                        value={data.dictionaries || ""}
                        onChange={({ target: { value } }) => updateTrainerData("dictionaries", value)}
                    />
                </InfoBlock>
            )}
        </TrainerContext.Consumer>
    );
};
